import { createRoot } from 'react-dom/client';

let root = null;

export function getBookshelfRoot() {
  if (!root) {
    root = createRoot(document.getElementById('bookshelf'));
  }
  return root;
}
